import { DictionaryType } from '../types/DictionaryType';

const STATIC: DictionaryType<string> = {
  backgroundColor: 'backgroundColor',
  backgroundColorHover: 'backgroundColorHover',
  linkBackgroundColor: 'linkBackgroundColor',
  linkActiveBackgroundColor: 'linkActiveBackgroundColor',
  linkHoverBackgroundColor: 'linkHoverBackgroundColor',
  subnavBackgroundColor: 'subnavBackgroundColor',
  separatorColor: 'separatorColor',
  subnavSeparatorColor: 'subnavSeparatorColor',
  imgBackgroundColor: 'imgBackgroundColor',
  imgUrl: 'backgroundImage',
  imgDisabled: 'backgroundImage',
  favicon: 'favicon',
  font: 'font-family',
  brand: 'brand',
  textColor: 'textColor',
  textColorHover: 'textColorHover',
  linkColor: 'linkColor',
  linkActiveColor: 'linkActiveColor',
  linkActiveIndicatorColor: 'linkActiveIndicatorColor',
  linkHoverColor: 'linkHoverColor',
};

const StyleService = {
  apply: (
    name: string,
    whietlabelingSettings: DictionaryType<DictionaryType<string>>,
    isImportant?: boolean
  ) => {
    return StyleService.prepareStyles(name, whietlabelingSettings, isImportant);
  },

  applyMany: (
    names: string[],
    whietlabelingSettings: DictionaryType<DictionaryType<string>>,
    isImportant?: boolean
  ) => {
    let result: any = {};

    for (let i = 0; i < names.length; i++) {
      result[names[i]] = StyleService.prepareStyles(names[i], whietlabelingSettings, isImportant);
    }

    return result;
  },

  prepareStyles: (
    name: string,
    whietlabelingSettings: DictionaryType<DictionaryType<string>>,
    isImportant?: boolean
  ) => {
    let cssRules: DictionaryType<string> = {};
    let isImgDisabled = false;

    if (whietlabelingSettings.hasOwnProperty(name)) {
      for (let instruction in whietlabelingSettings[name]) {
        let propertyValue = whietlabelingSettings[name][instruction];
        const propertyName = STATIC[instruction];

        if (instruction === 'imgUrl' && !isImgDisabled) {
          propertyValue = `${propertyValue}`;
        } else if (instruction === 'imgDisabled' && propertyValue === 'true') {
          isImgDisabled = true;
          propertyValue = 'none';
        }

        cssRules[propertyName] = `${propertyValue} ${isImportant ? `!important` : ``}`;
      }
    }

    return cssRules;
  },

  makeFaviconTag: (url: string) => {
    const nodeList = document.getElementsByTagName('link');

    for (var i = 0; i < nodeList.length; i++) {
      if (nodeList[i].getAttribute('rel') === 'shortcut icon') {
        nodeList[i].remove();
      }
    }

    let linkEl = document.createElement('link');

    linkEl.setAttribute('rel', 'shortcut icon');
    linkEl.setAttribute('href', url);

    document.head.appendChild(linkEl);
  },
};

export default StyleService;
